// @flow
import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';

import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { COLORS } from 'Components/utils/color/colors';
import { NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT } from 'Components/widgets/navigation/Navigation.constants';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';
import { ThumbnailNavigation } from 'Components/frameworks/thumbnail-navigation/ThumbnailNavigation.jsx';

import { type NavItem } from './NavigationLargeSubNavList.jsx';

type Props = {
  subItems: Array<NavItem>,
};

export function NavigationLargeSubNav(props: Props) {
  const { subItems = [] } = props;

  if (isEmpty(subItems)) {
    return null;
  }

  return (
    <div
      className="bg-white overflow-y-auto py-6 px-12"
      style={{ maxHeight: NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT }}
    >
      <ul className="flex flex-wrap -m-2 reset-list">
        {subItems.map(item => {
          const thumbnail = {
            imageUrl: item.thumbnail?.imageUrl || '',
            ratioKey: !isEmpty(item.subItems) ? ratioUtils.S : ratioUtils.XL,
          };

          return (
            <li className="w-1/4 p-2" key={item.label}>
              <ThumbnailNavigation
                hasImageBorder={item.hasImageBorder}
                label={item.label}
                link={isEmpty(item.subItems) ? item.link : null}
                seeMoreLabel={item.seeMoreLabel}
                thumbnail={thumbnail}
              >
                {!isEmpty(item.subItems) && (
                  <Fragment>
                    <ul className="reset-list font-bold font-sans text-gray-darker text-sm">
                      {(item.subItems || []).map(subitem => {
                        return subitem.label ? (
                          <li key={subitem.label}>
                            <TrackClick
                              {...subitem.link}
                              as={DynamicLink}
                              className="inline-block no-underline py-1 text-gray-darker focus:text-blue hover:text-blue transition-color"
                              data-testid="NavigationLargeSubNav-third-link"
                            >
                              {subitem.label}
                            </TrackClick>
                          </li>
                        ) : null;
                      })}
                    </ul>
                    {item.seeMoreLabel && (
                      <TextLink
                        {...item.link}
                        className="mt-2 uppercase"
                        color={COLORS.GRAY_MEDIUM}
                        label={item.seeMoreLabel}
                        theme="fancy"
                        trackingData={item.link.trackingData}
                      />
                    )}
                  </Fragment>
                )}
              </ThumbnailNavigation>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
